import * as Sentry from "@sentry/browser";
import { init } from "../actions";
import { logoutUser } from "./requests-api";
import { $, getUrlFlightSearchParams, setStoredAddress, checkEmptyValue } from "./utils";
import { store } from "../react-app";
import { webwidgetLogout } from "../zendesk/webwidget";
import { removeCookie } from "./cookie";

// Caminhos do checkout na SPA - Url
const inCheckoutPath = "(pagamento|pagamento-finalizado|relembrar-senha)";

/** Esconde busca do header dentro do processo de compra baseado na Url **/
export const hideHeaderSearch = () => {
	const pathname = window.location.pathname;

	if (pathname.match(new RegExp(inCheckoutPath + "|(login)" + "|(cadastro)")) !== null) {
		if ($("#trip_resume") == null) {
			return false;
		}
		$("#trip_resume").style.display = "none";
	} else if ($("#trip_resume") !== null) {
		$("#trip_resume").style.display = "block";
	}
};

/** Recupera informação da Url pra disparar a busca **/
export const getSearchFlightParams = () => {
	if (window.location.hash.match("#checkout") !== null) {
		// Adjuste to make calc of header height and add the same value as padding-top to body
		try {
			const header = document.querySelector('.newheader');
			const body = document.querySelector('body');
			const searchTools = document.querySelector('.search-tools');
			if (header.classList.contains('is-search-page') && window.innerWidth <= 1023) {
				body.setAttribute('style', `padding-top: ${header.offsetHeight}px`);
			}
		} catch(e) {
			console.error(e);
		}

		return false;
	} else if (window.location.href.match("/busca-passagens-aereas/(RT|OW)") !== null) {
		const flightParams = getUrlFlightSearchParams("/busca-passagens-aereas/");
		setStoredAddress();
		if (store.getState().searchParams.searchingFlights == false) {
			console.log("flight params: ", flightParams);
			store.dispatch(init(flightParams));
		}
	}
};

/** Checa se é a rota de logout pra executar funções relativas ao logout **/
export const checkIfIsLogout = () => {
	const pathname = window.location.pathname;

	if (pathname.match(/(logout)/)) {
		logoutUser()
			.then((response) => {
				localStorage.removeItem("au");
				removeCookie("au")
				window.sessionStorage.removeItem("activeCheckoutId");

				// Verifica se o logout retornou o parâmetro redirect
				const redirect = response.data.redirect;
				if (!checkEmptyValue(redirect)) {
					try {
						// Redireciona o usuário para a página vinda na resposta do logout
						const redirectLocation = new URL(redirect);
						window.location = redirectLocation.href;
						return;
					} catch (err) {
						Sentry.captureException(err);
					}
				}

				// Faz logout do Chat do Zendesk
				webwidgetLogout();

				window.location.pathname = "/";
			})
			.catch((error) => {
				alert("Logout Error");
			});
	}
};
